const documentType = [
  { value: 0, label: "CPF", ENUM: "CPF" },
  { value: 1, label: "CNPJ", ENUM: "CNPJ" },
  { value: 2, label: "NF", ENUM: "FISCAL_NOTE" },
  { value: 3, label: "Invoice", ENUM: "INVOICE" },
];

export default documentType;
